<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center">
                    <li class="nav-item theme-logo">
                        <router-link to="/leaderboard">
                            <img src="@/assets/images/logo.svg" class="navbar-logo" alt="logo" />
                        </router-link>
                    </li>
                    <li class="nav-item theme-text">
                        <router-link to="/leaderboard" class="nav-link"> ERMIS </router-link>
                    </li>
                </ul>
                <div class="d-none horizontal-menu">
                    <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-menu"
                        >
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </a>
                </div>

                <div style="width: 100% !important;" class=" d-none d-sm-block" >
                    <center v-if="!isAdminsRole">
                        <label class="text-success"> Recognition Credits: <b>{{myPointsOverview.weeklyRemainingPoints  }}</b></label>
                        &nbsp;|&nbsp;
                        <label class="text-warning"> My Reward Points: <b>{{myPointsOverview.walletPoints}}</b></label>
                    </center>

                    <center v-else>
                        <label class="text-success"> You're logged in as <b>{{ currentLoggedInUserGroup.toLocaleUpperCase().replace("_", " ")  }}</b></label>
                    </center>
                </div>
                <div class="navbar-item flex-row ms-md-auto">
                    <div class="dark-mode d-flex align-items-center">
                        
                        <a v-if="$store.state.dark_mode == 'light'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('dark')">
                            <LightSVG />
                            <span class="ms-2">Light</span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'dark'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('system')">
                            <DarkSVG />
                            <span class="ms-2">Dark</span>
                        </a>
                        <a v-if="$store.state.dark_mode == 'system'" href="javascript:;" class="d-flex align-items-center" @click="toggleMode('light')">
                            <SystemSVG />
                            <span class="ms-2">System</span>
                        </a>
                    </div>

                    <div class="dropdown nav-item language-dropdown btn-group hide-conten" >
                        <a href="javascript:;" id="ddllang" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only nav-link">
                            <img v-if="selectedLang" :src="require(`@/assets/images/flags/${selectedLang.code}.png`)" class="flag-width" alt="flag" />
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddllang">
                            <perfect-scrollbar>
                                <li v-for="item in countryList" :key="item.code">
                                    <a href="javascript:;" class="dropdown-item d-flex align-items-center" :class="{ active: locale === item.code }" @click.prevent="changeLanguage(item)">
                                        <img :src="require(`@/assets/images/flags/${item.code}.png`)" class="flag-width" alt="" /> <span>{{ item.name }}</span>
                                    </a>
                                </li>
                            </perfect-scrollbar>
                        </ul>
                    </div>

                    <!-- activity log -->
                    <ActivityLogDropDown />

                    <div class="dropdown nav-item user-profile-dropdown btn-group">
   
                        
                        <a href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only user nav-link">
                            <div class="nav-avatar">
                                <img :src="assetsHostURL + avatarInformation.image" />
                            </div>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
                            <li role="presentation">
                                
                                <div class="nav-avatar-dropdown d-flex flex-column align-items-center justify-content-center pt-0 pb-3 gap-2">
                                    <div class="img-container">
                                        <img :src="assetsHostURL + avatarInformation.image" />
                                    </div>
                                    <h6 class="avatar-name">
                                        {{avatarInformation.name}}
                                        <br>
                                        <label style="font-size: 13px;">{{avatarInformation.group}}</label>
                                    </h6>
                                </div>
                            </li>

                            <li role="presentation" >
                                <router-link to="/profile" class="dropdown-item">
                                    <UserSVG />
                                    Profile
                                </router-link>
                            </li>

                            <li role="presentation" class="hide-conten">
                                <router-link to="/auth/lockscreen" class="dropdown-item">
                                    <LockSVG />
                                    Lock Screen
                                </router-link>
                            </li>
                            <li role="presentation"  >
                                <a href="" class="dropdown-item" @click.prevent="changePassword()">
                                    <PencilSVG />
                                    Change Password
                                </a>
                            </li>
                            <li role="presentation" @click="logOutUser()">
                                <router-link to="#" class="dropdown-item">
                                    <LogoutSVG />
                                    Sign Out
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-menu"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>

                <!-- Portal vue/Teleport for Breadcrumb -->
                <div id="breadcrumb" class="vue-portal-target"></div>
            </header>
        </div>
        <!--  END NAVBAR  -->
    </div>
</template>

<style scoped>
    .hide-conten{
        display: none;
    }
</style>
<script setup>
    import { onMounted, ref, computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useStore } from 'vuex';
    import LogoutSVG from "@/components/svg/logout.vue"
    import UserSVG from "@/components/svg/user.vue"
    import PencilSVG from "@/components/svg/pencil.vue"
    import LockSVG from "@/components/svg/lock.vue" 
    import NotificationSVG from "@/components/svg/bell.vue" 
    import ActivityLogDropDown from "@/components/activity-log/ActivityLogDropDown.vue"
    import { LOG_OUT_USER } from '@/store/types/root/actions-types';
    import { EMPLOYEE_MODULE_NAME } from "@/store/module-names"
    import { GET_USER_REQUEST } from '@/store/modules/employee/action-types';
    import router from '@/router';
    import DarkSVG from "@/components/svg/theme-dark.vue"
    import LightSVG from "@/components/svg/theme-light.vue"
    import SystemSVG from "@/components/svg/theme-system.vue"
    
    const store = useStore();

    const selectedLang = ref(null);
    const countryList = ref(store.state.countryList);

    const i18n = useI18n();
    const {locale} = useI18n();

    const assetsHostURL = process.env.VUE_APP_ASSESTS_BUCKET_URL;
    const avatarInformation = ref({ name: '', group: '', image: '' });
    const currentLoggedInUserGroup = ref(localStorage.getItem("userType") + "".toLocaleLowerCase())
    const isAdminsRole = ref(currentLoggedInUserGroup.value === "admin" || currentLoggedInUserGroup.value === "super_admin");
    const myPointsOverview = computed(() => store.state.points.myPointsOverview);
    
    onMounted(async() => {
        selectedLang.value = window.$appSetting.toggleLanguage();
        toggleMode();
        const tokenLength = localStorage.getItem("IdToken") == null ? 0 : localStorage.getItem("IdToken").length
        if(tokenLength > 5){
            await getPointsRviewRequest()
        }
        if (localStorage.getItem("IdToken")!==null){
            await getUserRequest(localStorage.getItem("userId"))
        }
    });

    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };

    const changeLanguage = (item) => {
        selectedLang.value = item;
        window.$appSetting.toggleLanguage(item);

        i18n.locale.value = item.code;
    };
    const logOutUser = ()=>{
        store.commit("LOG_OUT_USER", false)
    }
    const changePassword = ()=>{
        const employeeID = localStorage.getItem("userId")
        router.push({ name: 'change-password', params: { employee_id: employeeID } });
    }

    import { POINTS_MODULE_NAME } from "@/store/module-names"
    import { MY_POINTS_OVERVIEW_REQUEST } from "@/store/modules/points/action-types"
    const isLoadingReviewPoints =  ref(false)
    const getPointsRviewRequest = async ()=> {
        
        let response = {}
            try{
                isLoadingReviewPoints.value = true
                response =   await store.dispatch(POINTS_MODULE_NAME + "/" + MY_POINTS_OVERVIEW_REQUEST);
                isLoadingReviewPoints.value = false
            }catch(error){
                isLoadingReviewPoints.value = false
            }
            return response
    }

    const getUserRequest = async (userID)=>{
        try {
            const response = await store.dispatch( EMPLOYEE_MODULE_NAME + "/" + GET_USER_REQUEST, userID);
            const statusCode = response.data.statusCode
            if(statusCode == 200) {
                let {fname, lname, image, group} =  response.data.body          
                // setting avatar details
                avatarInformation.value.name = `${fname} ${lname}`;
                avatarInformation.value.image = image;
                avatarInformation.value.group = group;

                // Capitalizing group
                group = group.split('_');
                for (var i = 0; i < group.length; i++) {
                    group[i] = group[i].charAt(0).toUpperCase() + group[i].slice(1).toLowerCase();
                }
                avatarInformation.value.group = group.join(' ');
            }
        } catch(error){
            console.log(error)
        }
    }
</script>
